"use client";
import { useQuery } from "@tanstack/react-query";
import { getBlogs } from "@/lib/actions/blogs/get/getBlogs";

export const useGetBlogs = (page: number = 1, perPage: number = 10, category?: string) => {
  return useQuery({
    queryKey: ["blogs", page, perPage, category],
    queryFn: () => getBlogs(page, perPage, category),
  });
};